import React from 'react'
import { makeStyles } from '@mui/styles'
import { CircularProgress } from '@mui/material'

const useStyles = makeStyles(theme => ({
  loading: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
  },
}))

const CenteredLoading = props => {
  const classes = useStyles(props)

  return (
    <div className={classes.loading}>
      <CircularProgress />
    </div>
  )
}

export default CenteredLoading
